import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { MaterialCarousel } from './components/MaterialCarousel';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream text-navy" data-id="element-0" data-mp="28sl5f2ubjwhm">
      <MetaPixel data-id="element-1" data-mp="23vuoyeelqyvo" />
      <UtmifyScript data-id="element-2" data-mp="23u9vks40xlze" />
      <CountdownBar data-id="element-3" data-mp="23ut9lxqjzq85" />
      <main data-id="element-4" data-mp="23ti864kkyuk7">
        <Hero data-id="element-5" data-mp="3ijxoypkvdyjd" />
        <StatsBar data-id="element-6" data-mp="3ikha0f5th31m" />
        <Difference data-id="element-7" data-mp="3iiwfgpji5k3r" />
        <Recognize data-id="element-8" data-mp="3ijfthv617oci" />
        <WhatsInside data-id="element-9" data-mp="3ii4t85bsoyq5" />
        <MaterialCarousel data-id="element-10" data-mp="3mlaxx8j9ehui" />
        <Bonuses data-id="element-11" data-mp="3mkhm3t5g125i" />
        <Offer data-id="element-12" data-mp="3mjzrt22ccy08" />
        <Guarantee data-id="element-13" data-mp="3mjg9hk8s47lo" />
        <Testimonials data-id="element-14" data-mp="3rc9e8848zfxr" />
        <Faq data-id="element-15" data-mp="3rbrcivytg9ig" />
        <FinalCta data-id="element-16" data-mp="3rdas0kcnegj6" />
      </main>
      <Footer data-id="element-17" data-mp="3rd18nfm3z7mg" />
    </div>;
}